"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _Alert = require("../alert/Alert");
var _toastModule = _interopRequireDefault(require("./toast.module.scss"));
var Toast = function Toast(props) {
  var toastList = props.toastList,
    _props$position = props.position,
    position = _props$position === void 0 ? 'top-right' : _props$position,
    _props$autoDeleteTime = props.autoDeleteTimeMs,
    autoDeleteTimeMs = _props$autoDeleteTime === void 0 ? 5000 : _props$autoDeleteTime;
  var _useState = (0, _react.useState)(toastList),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    list = _useState2[0],
    setList = _useState2[1];
  var deleteToast = function deleteToast(id) {
    var listItemIndex = list.findIndex(function (e) {
      return e.id === id;
    });
    var toastListItem = toastList.findIndex(function (e) {
      return e.id === id;
    });

    // we set the toast hidden first and then we remove it (this is to allow the css transition)
    list[listItemIndex].hidden = true;
    toastList[toastListItem].hidden = true;
    setList((0, _toConsumableArray2.default)(list));
    setTimeout(function () {
      list.splice(listItemIndex, 1);
      toastList.splice(toastListItem, 1);
      setList((0, _toConsumableArray2.default)(list));
    }, 500);
  };
  (0, _react.useEffect)(function () {
    setList((0, _toConsumableArray2.default)(toastList));
  }, [toastList]);
  (0, _react.useEffect)(function () {
    var timeout;
    if (autoDeleteTimeMs && toastList.length && list.length) {
      timeout = setTimeout(function () {
        deleteToast(toastList[0].id);
      }, autoDeleteTimeMs);
    }
    return function () {
      clearTimeout(timeout);
    };
  }, [toastList, autoDeleteTimeMs, list]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_toastModule.default['toast-container'], _toastModule.default[position])
  }, list.map(function (_ref, index) {
    var id = _ref.id,
      title = _ref.title,
      showClose = _ref.showClose,
      description = _ref.description,
      hidden = _ref.hidden,
      type = _ref.type;
    return /*#__PURE__*/_react.default.createElement(_Alert.Alert, {
      className: (0, _classnames2.default)(_toastModule.default['toast-alert'], (0, _defineProperty2.default)({}, _toastModule.default['toast-hidden'], hidden)),
      key: id || index,
      title: title,
      showClose: showClose,
      description: description,
      type: type
    });
  }));
};
exports.Toast = Toast;